import axios from "./axios-decorator";

const baseAxiosUrl = window.location.origin;

/**
* Create the user token.
*/
export const createUserToken = async (requestedScopes?: string): Promise<any> => {
    let url = `${baseAxiosUrl}/api/acs/createusertoken`;
    return await axios.getAnonymous(url);
}

/**
* Refresh the user token.
*/
export const refreshUserToken = async (userId: string, requestedScopes?: string): Promise<any> => {
    let url = `${baseAxiosUrl}/api/acs/refreshusertoken?userId=${userId}`;
    return await axios.getAnonymous(url);
}

/**
* Validates if the Acs is enabled or not.
*/
export const isAcsEnabled = async (): Promise<any> => {
    let url = `${baseAxiosUrl}/api/acs/isacsenabled`;
    return await axios.getAnonymous(url);
}

/**
* Validates if the Acs is enabled or not.
*/
export const getAcsFields = async (): Promise<any> => {
    let url = `${baseAxiosUrl}/api/acs/getacsfields`;
    return await axios.getAnonymous(url);
}

/**
* Validates if the Acs is enabled or not.
*/
export const acsMeetingError = async (userName: string | undefined, queueId: string): Promise<any> => {
    let url = `${baseAxiosUrl}/api/acs/acsmeetingerror?userName=${userName}&queueId=${queueId}`;
    return await axios.putAnonymous(url);
}


